const config = globalThis.MyConfig;

const setLocalValue = (key: keyof MyConfig, placeHolder: string, newValue: string | undefined) => {
  // if value is not placeholder (pipeline variable was set), ignore local value
  if (config[key] === placeHolder && newValue !== undefined) config[key] = newValue;
};

if (import.meta.env.VITE_API_URL && import.meta.env.VITE_CONNECTIONSTRING) {
  setLocalValue('REACT_APP_API_URL', '#{REACT_APP_API_URL}#', import.meta.env.VITE_API_URL);
  setLocalValue(
    'REACT_APP_CONNECTIONSTRING',
    '#{REACT_APP_CONNECTIONSTRING}#',
    import.meta.env.VITE_CONNECTIONSTRING
  );
}

if (import.meta.env.VITE_TURNSTILE_SITE_KEY) {
  setLocalValue(
    'REACT_APP_TURNSTILE_SITE_KEY',
    '#{REACT_APP_TURNSTILE_SITE_KEY}#',
    import.meta.env.VITE_TURNSTILE_SITE_KEY
  );
}

export const isNotProduction = config.environment !== 'production';

export default config;
